import { Inject, Injectable } from '@angular/core';
import { AbstractService } from './abstract-service.service';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, AppConfig } from './config';
import { Slide } from '../Models/slide';
import { Observable, map, catchError, of } from 'rxjs';
import { Slide as LibSlide } from "admin-common";

/**
 * Interface for the carousel slide
 */
interface CarouselSlideResponse {
  id: number;
  createdAt: string;
  updatedAt: string | null;
  ord: number;
  file: string | null;
  imageSrc: string;
  route: string;
}

@Injectable({
  providedIn: 'root',
})
export class CarouselService extends AbstractService<Slide, number> {
  url: string;

  constructor(
    protected override http: HttpClient,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    super(http);
    this.url = `${this.appConfig.apiEndpoint}/new/images-carousel`;
  }

  /**
   * Gets carousel slides and transforms them to the format expected by lib-accueil
   */
  getCarouselSlides(): Observable<LibSlide[]> {
    return this.http
      .get<CarouselSlideResponse[]>(
        `${this.appConfig.apiEndpoint}/new/images-carousel`
      )
      .pipe(
        map(
          (
            response:
              | CarouselSlideResponse[]
              | { body: CarouselSlideResponse[] }
          ) => {
            // Process the response based on its structure
            let carouselSlides: CarouselSlideResponse[] = [];
            if (Array.isArray(response)) {
              carouselSlides = response;
            } else if (response && 'body' in response) {
              carouselSlides = response.body;
            }

            // Map to the expected format
            return carouselSlides.map((slide: CarouselSlideResponse) => ({
              id: slide.id,
              imageUrl: slide.imageSrc,
              route: slide.route === 'undefined' ? undefined : slide.route,
            }));
          }
        ),
        catchError((error) => {
          // Return an empty array on error
          return of([]);
        })
      );
  }
}
